import Swiper from 'swiper';
import SwiperCore, {Navigation, Pagination, Lazy, EffectFade, Autoplay} from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Lazy, EffectFade, Autoplay]);


export default class SliderFactory {
    constructor()
    {
        this.sliders = document.querySelectorAll('.js-swiper-slider');
    }

    init()
    {
        if (!this.sliders) {
            return false;
        }

        const max_count = this.sliders.length;

        for (let i = 0; i < max_count; i++) {
            const elem = this.sliders[i];
            const id = elem.id;
            const data = elem.dataset.slider;

            if (!id || !data) {
                return false;
            }

            const slider = new Slider(id, data);
            slider.init();
        }

    }
}

class Slider {
    constructor(slider_id, slider_options)
    {
        this.id = slider_id;
        this.data = slider_options;
        this.slider_wrapper = document.querySelector('[data-swiper-wrapper="' + slider_id + '"]');
        this.slider = false;
    }

    init()
    {
        this.data = JSON.parse(this.data);

        this.createWrapper();
        this.createSlider();

        this.windowResizeSpy();


    }


    windowResizeSpy()
    {
        window.addEventListener('resize', () => {
            this.createWrapper();
            this.createSlider();
        })
    }

    createWrapper()
    {
        if (!this.slider_wrapper) {
            return false;
        }

        let w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight || e.clientHeight || g.clientHeight;

        if(x <= 992) {
          return false;
        }

        let container_width = this.slider_wrapper.clientWidth;
        let paddings = (x - container_width) / 2;

        let size = ((x - paddings + 16 ) > x - 16) ? x - 16 :  x - paddings + 16

        this.slider_wrapper.style.width = size + 'px';
        this.slider_wrapper.style.maxWidth = 'unset';
        this.slider_wrapper.style.marginRight = 'unset';
    }

    createSlider()
    {
        const id = '#' + this.id;
        this.slider = new Swiper(id, this.data);

        this.pauseAutoplayOnUserInteraction();
    }

    pauseAutoplayOnUserInteraction()
    {
        this.slider_wrapper.addEventListener('mouseenter', () => {
            this.slider.autoplay.stop();
        })

        this.slider_wrapper.addEventListener('mouseleave', () => {
            this.slider.autoplay.start();
        })
    }
}
